import { ButtonError } from '@flatsy/core/MaterialUi/Button'
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import React, { useContext } from 'react'
import clsx from 'clsx'
import { isFileError } from '@flatsy/utils/Functions/Files/IsFileError'
import { FileContext } from 'src/containers/Application/Files/Context'
import i18n from '@flatsy/utils/translations'
import { FilesStatus } from '@flatsy/types/Files'
import { useStyles } from './Style'
import { FilesListFilesItemProps } from './Type'

const FilesListFilesItem: React.FC<FilesListFilesItemProps> = ({ file }): React.ReactElement => {
  const { upload } = useContext(FileContext)
  const classes = useStyles()
  const error = isFileError(file)
  const handleFileError = () => {
    upload.replace(file)
  }

  const getFileStatus = (status: FilesStatus) => {
    switch (status) {
      case FilesStatus.TO_REVIEW:
        return i18n.t('waiting_for_review')
      case FilesStatus.VALIDATED:
        return i18n.t('validated')
      case FilesStatus.UNREADABLE:
        return i18n.t('unreadable')
      case FilesStatus.EXPIRED:
        return i18n.t('expired')
      case FilesStatus.NON_COMPLIANT:
        return i18n.t('non_compliant')
      default:
        return status
    }
  }

  return (
    <div className={clsx(classes.row, error && 'error')}>
      <div>
        <Body1 className={classes.title}>
          {file.name}
          {error &&
            ` - ${i18n.t('proof').toLowerCase()} ${getFileStatus(file.status).toLowerCase()}`}
        </Body1>
      </div>
      {error ? (
        <ButtonError onClick={handleFileError}>{i18n.t('change_this_file')}</ButtonError>
      ) : (
        <div className={classes.emptyButton} />
      )}
    </div>
  )
}

export default FilesListFilesItem
